import { loadModules } from 'esri-loader';
import { bootstrapJSAPI } from '../../../utils/esriLoader';

export default class AuthManager {
  constructor(appId, portalUrl, jsapiUrl, loginWithPopup, use3D, useWVLogin) {
    this.appId = appId;
    this.portalUrl = (useWVLogin) ? "https://wvdof.maps.arcgis.com" : portalUrl;
    this.jsapiUrl = jsapiUrl;
    this.loginWithPopup = loginWithPopup;
    this.use3D = use3D
  }

  startup = () => {

    return new Promise((resolve, reject) => {
      bootstrapJSAPI(this.portalUrl, this.jsapiUrl, this.use3D)
      .then(success => {
          loadModules([
            'esri/identity/IdentityManager', 'esri/identity/OAuthInfo'
          ])
          .then( ([esriId, OAuthInfo]) => {
            this.idManager = esriId;
            this.idManager.useSignInPage = !this.loginWithPopup;
            this.oAuthInfo = new OAuthInfo({appId: this.appId, portalUrl: this.portalUrl, popup: this.loginWithPopup});
            this.idManager.registerOAuthInfos([this.oAuthInfo]);
            resolve();
          });
      })
      .catch(err => { reject(); });
    });
  }

  login = () => {
    return new Promise((resolve, reject) => {
      this.checkLogin().then(
        success => {
          this.getUser().then(resolve, reject);
        },
        failed => {
          this.doLogin().then(user => resolve(user), error => reject(error));
        }
      )
    });
  }

  checkLogin = () => {
    return new Promise((resolve, reject) => {
      const sharingUrl = this.portalUrl + '/sharing';

      this.idManager.checkSignInStatus(sharingUrl)
        .then(credential => {
          window.api.setToken(credential.token);
          window.api.setCredential(credential);
          this.getUser().then(resolve, reject);
        })
        .catch(() => {
          reject('User is not logged in');
        });
    });
  }

  doLogin = () => {
  
    return new Promise((resolve, reject) => {
      const sharingUrl = this.portalUrl + '/sharing';

      this.idManager.getCredential(sharingUrl, {oAuthPopupConfirmation: false}).then((credential) => {
        this.getUser().then(resolve, reject);
      }).catch(err => { reject(); });
    });
  }

  getUser = () => {
    return new Promise((resolve, reject) => {
        loadModules(['esri/portal/Portal'])
        .then( ([Portal]) => {
          let portal = new Portal({
            url: this.portalUrl,
            authMode: "immediate"
          });
          portal.load().then(() => {
            this.user = portal.user;
            resolve(portal.user);
          }).catch(err => { reject(); });
        });
    });
  }

  logout = () => {
    loadModules(['dojo/cookie'])
    .then( ([cookie]) => {
      // dojo cookies hates me
      cookie('esri_auth', '{platbuilder: "logout"}', {
        expire: -1,
        expires: -1,
        path: '/'
      });
      this.idManager.destroyCredentials();

      window.api.logout().then(
        success => {
          window.location.reload();
        },
        error => {
          console.error(error);
        }
      )
    });
  }

  getToken = () => {
    return this.idManager.findCredential(this.portalUrl, this.user.username).token;
  }
}
